import { RepeatWrapping, Texture, TextureLoader } from "three"
import WaterNormals1024 from "./waternormals_1024.jpg"

let texture : Texture
const texturePromise = new Promise<Texture>((resolve, reject) => {
  texture = new TextureLoader().load(WaterNormals1024, (texture) => {
    texture.wrapS = texture.wrapT = RepeatWrapping
    resolve(texture)
  }, undefined, (error) => {
    reject(error)
  })
})

export function getWaterNormals1024Texture () {
  return texture
}

export function getWaterNormals1024TexturePromise () {
  return texturePromise
}